var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "rounded",
          attrs: { data: _vm.data, align: "center", border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { label: "Cód. Filial", width: "90", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.codigo))])]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Centro Distribuição",
              "min-width": "220",
              align: "left"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.descricao))])]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "UF", width: "60", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.estado.uf))])]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Status", width: "100", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.ativo != undefined
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type:
                                scope.row.ativo == true ? "success" : "danger"
                            }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  scope.row.ativo == true ? "ATIVO" : "INATIVO"
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Criado em", width: "180", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", { staticClass: "el-icon-time" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(scope.row.created_at, true))
                        )
                      ])
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Atualizado em", width: "180", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", { staticClass: "el-icon-time" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(scope.row.updated_at, true))
                        )
                      ])
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: { fixed: "right", align: "right", width: "50" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "bottom-end",
                                trigger: "hover"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "reference",
                                    size: "mini",
                                    type: "info",
                                    plain: "",
                                    circle: "",
                                    disabled: _vm.loading
                                  },
                                  slot: "reference"
                                },
                                [_c("i", { staticClass: "el-icon-more" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  style: {
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                    gap: "4px",
                                    maxWidth: "300px"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { style: { width: "100%" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          style: { width: "100%" },
                                          attrs: {
                                            slot: "reference",
                                            size: "mini",
                                            type: "primary",
                                            plain: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.dispatchRegionCd(
                                                scope.row.id
                                              )
                                            }
                                          },
                                          slot: "reference"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-right"
                                          }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass: "el-icon-map-location"
                                          }),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Ver regiões")])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { style: { width: "100%" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          style: { width: "100%" },
                                          attrs: {
                                            slot: "reference",
                                            size: "mini",
                                            type: "warning",
                                            plain: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.dispatchCd(
                                                scope.row.id
                                              )
                                            }
                                          },
                                          slot: "reference"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-edit"
                                          }),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Editar")])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticStyle: { width: "100%" },
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_c("i", { staticClass: "el-icon-menu" })]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "empty" },
            [
              _c("el-empty", {
                attrs: {
                  description: "Nenhum centro de distribuição disponível"
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "mt-3" },
        [
          _c(
            "el-col",
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pagination.data.currentPage,
                  "page-sizes": _vm.pagination.pageSizes,
                  "page-size": _vm.pagination.data.perPage,
                  layout: "total, sizes, prev, pager, next",
                  total: _vm.pagination.total
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pagination.data, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pagination.data, "currentPage", $event)
                  },
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("CdEditModal", { ref: "cdEditModal", on: { updated: _vm.fetch } }),
      _vm._v(" "),
      _c("CdRegionShowModal", { ref: "cdRegionShowModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-538c4a02", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-538c4a02","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/cd/CdList.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-538c4a02","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/cd/CdList.vue
// module chunks = 2